import {connect} from 'react-redux';
import {getListState} from '../../../utilites/helpers/crudListHelper';
import productActions from '../../../actions/shop/products';
import ProductGridList from '../ProductGridList/ProductGridList';

export default connect(
  (state) => getListState(state.shop.product),
  (dispatch) => ({
    fetch: () => dispatch(productActions.fetchList({sponsored: true})),
    fetchMore: () => dispatch(productActions.fetchListMore({sponsored: true}))
  })
)(ProductGridList);



// WEBPACK FOOTER //
// ./src/components/Shop/ProductGridSponsoredList/index.js